import styled from 'styled-components'
import BaseIcon from '../../IconV1'
import { v1 as color, media } from 'sidecar-design-library'

export const Wrapper = styled.div`
  font-size: 1.0625rem;
  line-height: 1.25rem;
  color: ${color.GREY};
  margin: -0.0625rem 0;

  ${media.belowMobile`
    min-width: 320px;
  `}
`

export const Badge = styled(BaseIcon).attrs({ name: 'badge' })`
  font-size: 1.0625rem;
  color: ${color.SCOOTER};
  margin: 0 0.25rem 0 0;
`

export const BoldText = styled.span`
  font-weight: 700;
`

export const RatingTooltip = styled.span`
  visibility: hidden;
  background-color: #474747;
  color: ${color.WHITE};
  text-align: left;
  border-radius: 5px;
  padding: 5px 10px;

  /* Position the tooltip */
  position: absolute;
  z-index: 10;
  bottom: -3.75rem;
  left: calc(50%);
  transform: translateX(-50%);
  white-space: nowrap;
  margin: 5px;

  ${media.desktopAndUp`
    ${
      '' /* shift tooltip left if there is a rating and not on details page to avoid getting cut off */
    }
    left: calc(50% - ${({ fullRatingsDisplayBool, reviewCount }) =>
      !fullRatingsDisplayBool && reviewCount > 0 ? '33px' : '0px'});
  `}

  font-family: 'sidecarta-sans', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
`

export const RatingTooltipContainer = styled.span`
  position: relative;
  display: inline-block;
  white-space: pre-wrap;

  ${media.aboveMobile`
    &:hover ${RatingTooltip} {
      visibility: visible;
    }
  `}
`

export const CMSTooltip = styled(RatingTooltip)`
  bottom: -7.5rem;
  left: 1.875rem;

  ${media.tabletAndBelow`
    bottom: -8.125rem;
  `}
`

export const CMSTooltipContainer = styled(RatingTooltipContainer)`
  color: ${color.AQUAMARINE};

  ${media.aboveMobile`
    &:hover ${CMSTooltip} {
      visibility: visible;
    }
  `}
`
